import { push } from 'connected-react-router';
import { EventTypes } from 'redux-segment';
import { CREATE_COMPANY_SELECT_TYPE } from './constants';
import {
  applyCompanyAndProject,
  dashboardGetProjectsSuccess,
  dashboardResetProjectsNewMessagesCountSuccess,
} from '../dashboard/actions';
import { appFetchingData } from '../../actions';
import { bulkFilesS3SignedPut } from '../../util/s3';
import _cloneDeep from 'lodash.clonedeep';
import { addCommonFormikErrorsIfEmpty, errorsTransformAxiosToFormik } from '../../util/error';
import { signInCompleteUserSuccess } from '../sign/actions';
import { sessionSetLastCompanyId } from '../../util/session';

export function companyCreateSelectTypeSuccess(companyType) {
  return {
    type: CREATE_COMPANY_SELECT_TYPE,
    companyType,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function companyCreateNew(data, setSubmitting, setErrors) {
  return async (dispatch, getStore, services) => {
    dispatch(appFetchingData(true));
    try {
      let payload = _cloneDeep(data);
      if (payload.supplier) {
        if (payload.supplier.photoFiles && payload.supplier.photoFiles.length > 0) {
          payload.supplier.photos = await bulkFilesS3SignedPut(
            'supplierPhoto',
            payload.supplier.photoFiles
          );
          delete payload.supplier.photoFiles;
        }
      }

      if (payload.logoFile) {
        const params = {
          objectType: 'companyLogo',
          contentType: payload.logoFile.type,
          name: payload.logoFile.name,
        };
        const signedRes = await services.api.signS3Put(params);
        await services.s3.presignedPut(
          signedRes.data.url,
          payload.logoFile,
          signedRes.data.headers
        );
        payload.logo = signedRes.data.key;
        delete payload.logoFile;
      }

      const res = await services.api.companyPost(payload);
      const companies = getStore().account.companies;
      const companyId = res.data._id;

      const userRes = await services.api.userGet();
      sessionSetLastCompanyId(companyId);
      await applyCompanyAndProject(
        dispatch,
        services.api,
        userRes.data,
        [...companies, res.data],
        getStore
      );

      dispatch(dashboardGetProjectsSuccess([]));
      dispatch(dashboardResetProjectsNewMessagesCountSuccess());
      dispatch(signInCompleteUserSuccess(userRes.data));

      dispatch(appFetchingData(false));
      dispatch(push('/dashboard'));
    } catch (rej) {
      const errors = errorsTransformAxiosToFormik(rej);
      setErrors(addCommonFormikErrorsIfEmpty(errors));
      setSubmitting(false);
      dispatch(appFetchingData(false));
    }
  };
}



// WEBPACK FOOTER //
// ./src/container/company/actions.js